import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { PicklistModalComponent, PicklistView } from '../../../shared/modals/picklist-modals/picklist-modal/picklist-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ContactViewModalService {

  @Output() modelChanged = new EventEmitter<any>(); 

  constructor(  private modalService: NgbModal) { }

  openModal(model?: any) {
    var modalRef!: NgbModalRef;
    modalRef = this.modalService.open( PicklistModalComponent, { windowClass : "customModalClassUnderName",size: 'xl', centered: false, backdrop: 'static', keyboard: false, scrollable: true });
    modalRef.componentInstance.model = model;
    modalRef.componentInstance.display = PicklistView.ContactView;

    var sub: Subscription =  modalRef.closed.subscribe(()=>{
      if(modalRef.componentInstance.model.id){
        this.modelChanged.emit(modalRef.componentInstance.model);
      }
      sub.unsubscribe();
    })
  }
}

